// #region Actions
const actions = {
  async addReportUrlRequest({commit}, {time, name, extension = 'pdf'}) {
    commit('addReportUrlRequest', {time, name, extension});
  },
  async completeReportUrl({commit},
    {url,
      timeStart,
      timeFinish},
  ) {
    commit('completeReportUrl',
      {url,
        timeStart,
        timeFinish},
    );
  },
  async completeReportBlob({commit},
    {blob,
      timeStart,
      timeFinish},
  ) {
    commit('completeReportBlob',
      {
        blob,
        timeStart,
        timeFinish,
      },
    );
  },
  async removeReportUrl({commit}, {timeStart}) {
    commit('removeReportUrl', {timeStart});
  },
  async cleanCompletedReportUrls({commit}) {
    commit('cleanCompletedReportUrls');
  },
  async cleanReportUrls({commit}) {
    commit('cleanReportUrls');
  },
};
// #endregion

// #region Getters
const getters = {
  reportsByTimeStart: (state) => {
    const sortedReports = [...state.reportUrls];
    return sortedReports.sort((r1, r2) => r2.timeStart - r1.timeStart);
  },
};
// #endregion

// #region Mutations
const mutations = {
  addReportUrlRequest(state, {time, name, extension}) {
    const found = state.reportUrls.find((rurl) => rurl.timeStart === time);
    if (!found) {
      state.reportUrls.push({
        url: null,
        name: name,
        timeStart: time,
        timeFinish: null,
        extension,
      });
    }
  },
  completeReportUrl(state, {url, timeStart, timeFinish}) {
    const reg = state.reportUrls.find((r) => r.timeStart === timeStart);
    if (!!reg) {
      reg.url = url;
      reg.timeFinish = timeFinish;
    }
  },
  completeReportBlob(state, {blob, timeStart, timeFinish}) {
    const reg = state.reportUrls.find((r) => r.timeStart === timeStart);
    if (!!reg) {
      reg.url = URL.createObjectURL(blob);
      reg.timeFinish = timeFinish;
    }
  },
  removeReportUrl(state, {timeStart}) {
    state.reportUrls = state.reportUrls.filter((rurl) => rurl.timeStart !== timeStart);
  },
  cleanCompletedReportUrls(state) {
    state.reportUrls = state.reportUrls.filter((rurl) => !!rurl.timeFinish);
  },
  cleanReportUrls(state) {
    state.reportUrls = [];
  },
};
// #endregion

// #region State
const state = () => {
  return {
    reportUrls: [],
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = []; // Submodules
// #endregion


export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  state,
};
